<template lang="pug">
  .lista-clientes
    .title
      span Usuarios del cliente {{ cliente.nombre }}

    .body
      table.table.is-striped.is-bordered
        thead
          th Email
          th Nombre
          th Cargo
          th Telefono
          th Password
          th
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="o in lista"
            key="o"
          )
            template(v-if="!o.isEditing")
              td {{ o.usuario }}
              td {{ o.nombre }}
              td {{ o.cargo }}
              td {{ o.telefono }}
              td {{ o.password }}
              td
                .contenedor-acciones
                  button.button.is-small(@click="o.isEditing = true") Editar
                  button.button.is-small.is-danger(@click="remover(o)") Eliminar
            template(v-else)
              td
                input(v-model="o.usuario")
              td
                input(v-model="o.nombre")
              td
                input(v-model="o.cargo")
              td
                input(v-model="o.telefono")
              td
                input(v-model="o.password")
              td
                .contenedor-acciones
                  button.button.is-small.is-primary(@click="guardar(o)") Guardar
                  button.button.is-small(@click="o.isEditing = false") Cancelar

          template(v-if="isAdding")
            tr.row-table(key="nuevo")
              td
                input(v-model="nuevo.usuario")
              td
                input(v-model="nuevo.nombre")
              td
                input(v-model="nuevo.cargo")
              td
                input(v-model="nuevo.telefono")
              td
                input(v-model="nuevo.password")
              td
                .contenedor-acciones
                  button.button.is-small.is-primary(@click="insertar()") Guardar
                  button.button.is-small(@click="isAdding = false") Cancelar

      div
        button.button(@click="isAdding = true") Nuevo
</template>

<script>
import { apiGet, apiPost, apiPut, apiDelete, notify } from '../util/general'
export default {
  name: 'cliente_contact_list',
  props: ['cliente'],
  data () {
    return {
      isLoading: true,
      lista: [],
      clienteSeleccionado: {},
      nuevo: {
        usuario: '',
        nombre: '',
        cargo: '',
        telefono: '',
        password: ''
      },
      seleccionado: false,
      isAdding: false
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = { codigo: vm.cliente.codigo }
      apiGet(vm, '/admin/cliente/contacto', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    remover (o) {
      var vm = this

      var obj = {
        usuario: o.usuario
      }

      apiDelete(vm, '/admin/cliente/contacto', obj, function (data) {
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    guardar (o) {
      var vm = this
      var obj = {
        usuario  : o.usuario,
        nombre   : o.nombre,
        cargo    : o.cargo,
        telefono : o.telefono,
        password : o.password
      }

      apiPut(vm, '/admin/cliente/contacto', obj, function (data) {
        notify(vm, 'success', '', 'Datos guardados correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    insertar () {
      var vm = this
      var obj = {
        usuario       : vm.nuevo.usuario,
        nombre        : vm.nuevo.nombre,
        cargo         : vm.nuevo.cargo,
        telefono      : vm.nuevo.telefono,
        password      : vm.nuevo.password,
        codigoCliente : vm.cliente.codigo,
        razonSocial   : vm.cliente.nombre
      }

      apiPost(vm, '/admin/cliente/contacto', obj, function (data) {
        notify(vm, 'success', '', 'Datos guardados correctamente')
        vm.nuevo = {
          usuario  : '',
          nombre   : '',
          cargo    : '',
          telefono : '',
          password : ''
        }
        vm.isAdding = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-acciones
    display flex
    .button
      margin 0px 10px
      flex 1
</style>



// WEBPACK FOOTER //
// Component_Cliente_Contact_List.vue?24a51c81